module.exports = __webpack_public_path__ + "img/12.5343988e.jpg";